
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div className='title'>Renseignements techniques</div>
    <p>{`Les cartes de dangers naturels des cantons ont été acquise par notre équipe de datajournalistes sous forme numérique, puis réunie dans une forme unique. Ces cartes sont aussi accessibles sur les différents portails cantonaux. Elles y sont parfois plus complètes, indiquant des dangers supplémentaires (glissement de terrain ou chute de pierre) ou les risques existant dans des zones inhabitées.`}</p>
    <p>{`Les liens vers ces cartes figurent ci-dessous, dans le tableau indiquant la source de nos données. Y figure aussi date à laquelle nous avons acquis ces données. La carte figurant sur ce site ne sera pas mise à jour.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;